"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _AccordionPanel = _interopRequireDefault(require("@insided/deprecated-control/panel/AccordionPanel"));

var _EnableForHttpOrHttps = _interopRequireDefault(require("@insided/deprecated-control/integrations/components/bi-tools-connector/EnableForHttpOrHttps"));

var _EnableForEmail = _interopRequireDefault(require("@insided/deprecated-control/integrations/components/bi-tools-connector/EnableForEmail"));

var _Message = require("@insided/deprecated-control/ui-components/Message");

var NotificationTabs = function NotificationTabs(_ref) {
  var targets = _ref.targets,
      requestState = _ref.requestState,
      setRequestState = _ref.setRequestState;
  var HttpOrHttpPanel = {
    body: [(0, _preact.h)(_EnableForHttpOrHttps.default, {
      key: "enablewebhook",
      targets: targets,
      requestState: requestState,
      setRequestState: setRequestState
    })],
    customClass: 'panel__body_without_header scrollable',
    collapsible: false
  };
  var EmailPanel = {
    body: [(0, _preact.h)(_EnableForEmail.default, {
      key: "enableemail",
      targets: targets,
      requestState: requestState,
      setRequestState: setRequestState
    })],
    customClass: 'panel__body_without_header'
  };
  return (0, _preact.h)("div", {
    className: "installation__tab__wrapper"
  }, (requestState.type === 'danger' || requestState.type === 'info') && (0, _preact.h)(_Message.Message, {
    text: requestState.message,
    title: requestState.title,
    variant: requestState.type,
    customClass: "notification-message-".concat(requestState.type)
  }), requestState.title !== 'Unable to Fetch Data' && (0, _preact.h)("div", {
    className: "installation__tab installation__connect_with_zapier_tab"
  }, (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: 0,
    panels: [HttpOrHttpPanel]
  })), requestState.title !== 'Unable to Fetch Data' && (0, _preact.h)("div", {
    className: "installation__tab installation__connect_with_zapier_tab"
  }, (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: 0,
    panels: [EmailPanel]
  })));
};

var _default = NotificationTabs;
exports.default = _default;